import type { Migration, MigrationInput } from './types';

export function createMigration({
    migrateVideo,
    migrateTemplate = (template) => template,
    migrateScene = (scene) => scene,
}: MigrationInput): Migration {
    return {
        migrateVideo,
        migrateTemplate,
        migrateScene,
    };
}
